import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Vat\CheckVatNumberController::__invoke
* @see app/Http/Controllers/Vat/CheckVatNumberController.php
* @route '/api/vat/check'
*/
const CheckVatNumberController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckVatNumberController.url(options),
    method: 'get',
})

CheckVatNumberController.definition = {
    methods: ["get","head"],
    url: '/api/vat/check',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Vat\CheckVatNumberController::__invoke
* @see app/Http/Controllers/Vat/CheckVatNumberController.php
* @route '/api/vat/check'
*/
CheckVatNumberController.url = (options?: RouteQueryOptions) => {
    return CheckVatNumberController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Vat\CheckVatNumberController::__invoke
* @see app/Http/Controllers/Vat/CheckVatNumberController.php
* @route '/api/vat/check'
*/
CheckVatNumberController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: CheckVatNumberController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Vat\CheckVatNumberController::__invoke
* @see app/Http/Controllers/Vat/CheckVatNumberController.php
* @route '/api/vat/check'
*/
CheckVatNumberController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: CheckVatNumberController.url(options),
    method: 'head',
})

export default CheckVatNumberController